import { ChangeEventHandler, FC, useEffect, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import { useTranslation } from 'react-i18next';
import { v4 } from 'uuid';

import { TextField } from '@mui/material';

import { CustomField } from '@bandido/shared/types';

import { HtmlForEmail } from './HtmlForEmail';

interface FixedFormProps {
  fields: CustomField[];
  fieldValues: { [key: string]: any };
  agencyId: string;
  workflowId: string;
  title: string;
}

export const FixedForm: FC<FixedFormProps> = ({ title, fields, fieldValues, agencyId, workflowId }) => {
  const { t } = useTranslation();
  const [values, setValues] = useState<{ name: string; lastName: string; emailAddress: string }>({
    name: '',
    lastName: '',
    emailAddress: '',
  });

  const [htmlForEmail, setHtmlToEmail] = useState('');

  const handleChangeValues: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> = (e) => {
    if (e.target?.name) {
      setValues((prev) => ({
        ...prev,
        [e.target.name]: e.target.value,
      }));
    }
  };

  useEffect(() => {
    const html = ReactDOMServer.renderToString(
      <HtmlForEmail
        fields={fields}
        fieldValues={fieldValues}
        name={values.name}
        lastName={values.lastName}
        email={values.emailAddress}
      />,
    );
    setHtmlToEmail(html);
  }, [values, fields, fieldValues]);

  return (
    <>
      <input type="hidden" name="title" key="title" value={title} />

      <input type="hidden" name="agencyId" key="agencyId" value={agencyId} />

      <input type="hidden" name="workflowId" key="workflowId" value={workflowId} />

      <input
        type="hidden"
        name="emailSubject"
        key="emailSubject"
        value={t('supportForms.fields.emailSubject', { title, code: v4() })}
      />

      <input type="hidden" name="emailHtml" key="emailHtml" value={htmlForEmail} />

      <TextField
        fullWidth
        required
        key="name"
        name="name"
        margin="normal"
        size="small"
        label={t('supportForms.fields.name')}
        inputProps={{ maxLength: 50 }}
        onChange={handleChangeValues}
      />

      <TextField
        fullWidth
        required
        key="lastName"
        name="lastName"
        margin="normal"
        size="small"
        label={t('supportForms.fields.lastName')}
        inputProps={{ maxLength: 50 }}
        onChange={handleChangeValues}
      />

      <TextField
        fullWidth
        required
        key="emailAddress"
        name="emailAddress"
        margin="normal"
        size="small"
        type="email"
        label={t('supportForms.fields.email')}
        inputProps={{ maxLength: 100 }}
        onChange={handleChangeValues}
      />
    </>
  );
};
